module.exports = __webpack_public_path__ + "img/jonas-kakaroto-BHdZZQWrcwM-unsplash.88b9f891.jpg";